export const Input = ({
  value,
  onChange,
  label,
  required,
  placeholder,
  error,
  type,
  labelClassName = "input-label",
  className = "",
  hideRequiredLabel = false,
}) => {
  return (
    <section className="input-main">
      <label className={labelClassName} htmlFor={label}>
        {label}
        {hideRequiredLabel === false && <span>{required ? "Required" : ""}</span>}
      </label>
      <input
        id={label}
        name={label}
        className={`input-proper ${error ? "error" : ""} ${className ? className : ""}`}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        type={type}
      />
      <p className="input-error">{error}</p>
    </section>
  );
};
